import { render } from "./FeaturedMessageItem.vue?vue&type=template&id=56f1d310&scoped=true"
import script from "./FeaturedMessageItem.vue?vue&type=script&lang=js"
export * from "./FeaturedMessageItem.vue?vue&type=script&lang=js"

import "./FeaturedMessageItem.vue?vue&type=style&index=0&id=56f1d310&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f1d310"]])

export default __exports__